
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/NumberInput.html",
      function () {
        return require("private-next-pages/Forms/NumberInput.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/NumberInput.html"])
      });
    }
  